import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '@services/storage.service';
import { ToastService } from '@shared/services/toast.service';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { DevicesService } from 'src/app/views/main/intranet/devices/devices.service';
import { BaseChartDirective } from 'ng2-charts';
@Component({
  standalone: false,
  selector: 'app-billing-summary',
  templateUrl: './billing-summary.component.html',
  styleUrls: ['./billing-summary.component.scss'],
})
export class BillingSummaryComponent implements OnInit {
  storageUsed: number = 0.0;
  totalStorage: number = 5;
  usagePercentage: number = 0;
  userId: string = '';

  // Acceso al gráfico
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  pieChartLabels: string[] = ['Usado', 'Disponible'];
  pieChartData: ChartData<'pie'> = {
    labels: this.pieChartLabels,
    datasets: [
      {
        data: [],
        backgroundColor: ['#0387d1', '#e0e0e0'],
        hoverBackgroundColor: ['#0056b3', '#c0c0c0'],
        borderWidth: 3,
      },
    ],
  };

  pieChartType: ChartType = 'pie';
  pieChartOptions: ChartConfiguration<'pie'>['options'] = {
    responsive: true,
    plugins: { legend: { display: true } },
  };

  constructor(
    private devicesService: DevicesService,
    private toastService: ToastService,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.initializeUser();
  }

  private initializeUser(): void {
    if (this.isSuperAdmin()) {
      this.route.params.subscribe(
        (params) => {
          this.userId = params.userId;
          this.getUserDevices();
        },
        (error) =>
          this.toastService.errorToast('Error al obtener el dispositivo')
      );
    } else {
      this.userId = this.storageService.get('userId');
      this.getUserDevices();
    }
  }

  isSuperAdmin(): boolean {
    const role = this.storageService.get('roleName').toLowerCase();
    return role === 'superadmin' || role === 'admin';
  }

  private getUserDevices(): void {
    this.devicesService.getUserDevices(this.userId).subscribe(
      (response: any[]) => {
        this.updateStorageUsage(response);
        this.cdr.detectChanges(); // Forzar detección de cambios
      },
      () => this.toastService.errorToast('Error al obtener los datos')
    );
  }

  private updateStorageUsage(response: any[]): void {
    const additionalStorageUsed = response.length * 0.1;
    this.storageUsed += additionalStorageUsed;
    this.usagePercentage = (this.storageUsed / this.totalStorage) * 100;
    this.updateChartData();
  }

  private updateChartData(): void {
    this.pieChartData.datasets[0].data = [
      this.storageUsed,
      this.totalStorage - this.storageUsed,
    ];

    this.cdr.detectChanges(); // Forzar que Angular actualice la vista

    // Forzar actualización del gráfico
    if (this.chart) {
      this.chart.update();
    }
  }
}
